export default __webpack_public_path__ + "static/media/banner-img.1a2cf7b5.png";